import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// new Vue({
//   render: h => h(App),
// }).$mount('#faz-mapbox-scrollytelling')


console.log('main.js 1000')

setTimeout(() => {
  /* eslint-disable no-new */
  Array.prototype.forEach.call(document.querySelectorAll('.mapbox-scrollytelling'), function (instance, i) {
    console.log(instance.id)
    window['vm' + i] = new Vue({
      // data: String(instance.id),
      el: '#' + instance.id,
      render: h => h(
        App,
        {
          props: {
            id: instance.id
          }
        })
    })
  })
}, 1000);